import { render, staticRenderFns } from "./service-list-table.vue?vue&type=template&id=23598551&"
import script from "./service-list-table.vue?vue&type=script&lang=js&"
export * from "./service-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports